import env from './../../env'

// const base = env.development ? env.API_BASE : 'https://api.staging.paylater.ng';
console.log(process.env.NODE_ENV);
const base = env.API_BASE
  || (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging'  ? 'https://api.staging.paylater.ng' : 'https://api.getcarbon.co');

const app_getcarbon_base = env.APP_GETCARBON_CO_BASE;
const customer_success_base = env.CUSTOMER_SUCCESS_BASE || "https://customersuccess.getcarbon.co/portal/api";
const customer_success_portal_id = env.CUSTOMER_SUCCESS_PORTAL_ID || "edbsn5d515ec3f7558702839abc2d4c9575a2b0d4d612f68ff4461c5a614ed065964a";
export default {
    base,
    user: {
        login: base + '/web/user/login',
        requestOTP: base + '/web/user/otp',
        requestOTPToBlockAccount: base + '/web/user/otp/block',
        verifyBlockOTP: base + '/web/user/block',
        verifyOTP: base + '/web/user/otp/verify',
        signup: base + '/web/user/create',
        forget: base + '/web/user/verify',
        reset: base + '/web/user/pin',
        updateProfile: base + '/web/user',
        updateAvatar: base + '/web/upload/picture',
    },
    loan: {
        status: base + '/web/loan/status',
        payments: base + '/web/loan/payments',
        fullHistory: base + '/web/loan/full-history',
        history: base + '/web/loan/history',
        loanRedirect: app_getcarbon_base + '/#/pay/pay-now',
    },
    wallet: {
        activeWallet: base + '/web/wallet',
        wallet: base + '/web/wallet',
        serviceCharge: base + '/web/xps/walletfund/serviceCharge?',
        walletFund: base + '/web/xps/walletfund',
        walletVerify: base + '/web/xps/walletfund/verify/',
        transactionStatus: base + '/web/xps/walletfund/status/',
    },
    payment: {
        recent: base + '/web/xps/payments/recent?',
        history: base + '/web/xps/payments/history?',
        recurring: base + '/web/xps/payments/recurring?'
    },
    billing: {
        paymentInstruments: base + '/web/billing/payment-instruments',
        paymentStatus: base + '/web/billing/payments/',
        billers: base + '/web/xps/billers',
        bankList: base + '/bank-list'
    },
    airtime: {
        networks: base + '/web/xps/topup/networks',
        getMobileNetwork: base + '/web/xps/topup/lookup/',
        topup: base + '/web/xps/topup',
        saved: base + '/web/xps/topup/saved',
        recurring: base + '/web/xps/topup/recurring',
        updateRecurring: base + '/web/xps/topup/recurring/',
        deleteRecurring: base + '/web/xps/topup/recurring/',
        deleteSaved: base + '/web/xps/topup/saved/',
        history: base + '/web/xps/topup/history?',
        transactionStatus: base + '/web/xps/topup/status/'
    },
    billsPayment: {
        saved: base + '/web/xps/bills/saved',
        history: base + '/web/xps/bills/history',
        recent: base + '/web/xps/bills/recent',
        recurring: base + '/web/xps/bills/recurring',
        customerDetails: base + '/web/xps/bills/customerDetails/',
        pay: base + 'web/xps/bills',
        category: base + '/web/xps/categories/',
        categories: base + '/web/xps/categories',
    },
    creditReport: {
        report: base + '/web/credit-report',
    },
    sendMoney: {
        bankList: base + '/web/xps/ft/banks',
        fundTransfer: base + '/web/xps/ft',
        interTransfer: base + '/web/wallet/transfer',
        history: base + '/web/xps/ft/history',
        recent: base + '/web/xps/ft/recent',
        walletRecent: base + '/web/wallet/transactions',
        recurring: base + '/web/xps/ft/recurring',
        saved: base + '/web/xps/ft/saved',
        serviceCharge: base + '/web/xps/ft/serviceCharge?',
        status: base + '/web/xps/ft/transactions/',
        customerLookup: base + '/web/wallet/phone-lookup',
        bankAccountLookup: base + '/web/xps/ft/nameEnquiry/',
        transactionStatus: base + '/web/xps/ft/status/',
        updateRecurring: base + '/web/xps/ft/recurring/',
        deleteSaved: base + '/web/xps/ft/saved/',
        deleteRecurring: base + '/web/xps/ft/recurring/',
    },
    zoho: {
        complaint: `${customer_success_base}/composetickets?portalId=${customer_success_portal_id}`,
        fileUpload: `${customer_success_base}/uploads?portalId=${customer_success_portal_id}`
    },
    config: {
        vars: base + '/web/config'
    }
};
